import styled from 'styled-components'

import { style } from 'theme'

type Props = {
  bold?: boolean
  textAlign?: string
}

const Title = styled('h1')`
  color: ${style(theme => theme.colors.slate)};
  font-size: 22px;
  font-weight: ${(props: Props) => (props.bold ? '600' : '400')};
  margin: 0;
  line-height: 1.37;
  text-align: ${(props: Props) => (props.textAlign ? props.textAlign : 'unset')};
`

export default Title
